import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";

import { APPEND_SEARCH_RESULTS, SET_SEARCH_FINISHED, SET_SEARCH_ISREPOSITORY } from "../actions/actionTypes";

import searchService from "../services/searchService"
import SearchResults from "../components/SearchResults"
import Spinner from '../components/Spinner'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  }
}));

const RESULTS_PER_PAGE = 20;

export default function SearchResult(props) {
  const classes = useStyles();

  const dispatch = useDispatch();
  const searchState = useSelector(state => state.search);
  const [isLoading, setIsLoading] = useState(false);
  const [isRepository, setIsRepository] = useState(false);

  const fetchData = () => {
    const queryParams = new URLSearchParams(props.location.search);

    const params = {
      title: queryParams.get('title'),
      author: queryParams.get('author'),
      subject: queryParams.get('subject'),
      library: queryParams.get('lib'),
      materialType: queryParams.get('material'),
      isRepository: queryParams.get('repository') || false,
      limit: RESULTS_PER_PAGE,
      offset: searchState.offset,
    };
    
    searchService(params)
    .then(response => {
        setIsLoading(false)
        if (!!response.data.length && response.data[0].httpCode === 500) throw "ERRO"

        if (params.isRepository) {
            setIsRepository(true);
            dispatch({ type: APPEND_SEARCH_RESULTS, payload: response.data.results });
            dispatch({ type: SET_SEARCH_ISREPOSITORY, payload: true });

            if (!response.data.next)
                dispatch({ type: SET_SEARCH_FINISHED });
        } else {
            dispatch({ type: APPEND_SEARCH_RESULTS, payload: response.data });

            if (response.data.length < RESULTS_PER_PAGE)
                dispatch({ type: SET_SEARCH_FINISHED });
        }
    })
    .catch(result => {
        
      setIsLoading(false)
      props.history.replace({
        pathname: '/search',
        state: {
          error: true,
          message: 'Um erro aconteceu na sua solicitação. Por favor tente novamente em alguns instantes.'
        }
      })
    })
  };
  
  const isEmptySearch = searchState.results.length === 0;

  useEffect(() => {
    if(isEmptySearch) {
      setIsLoading(true)
      fetchData()
    } 
  }, []);

  return (
    <div className={classes.root}>
      <List className={classes.root}>
        {!isEmptySearch ? (
          <SearchResults
            data={searchState}
            fetchData={fetchData}
            history={props.history}
            isRepository={isRepository}
          />
        ) : (!isLoading && (
          <Box p={2}>
            <Typography align="center" variant="body1" color="primary">
              Nenhum material encontrado para esse critério de busca
            </Typography>
          </Box>
        ))}
      </List>

      {isLoading && <Spinner />}

      <Box display="flex" flexGrow={1} p={1} justifyContent="center">
        {!isLoading && 
          <Button
            fullWidth={true}
            color="primary"
            onClick={() => props.history.goBack()}
          >
            Voltar
          </Button>
        }
      </Box>
    </div>
  );
}
